import React, { useState, useEffect } from 'react';
import './PoshmarkIntegrationPage.css';

// 🔥 YEH DEFINITE RHAHNA CHAHIYE
const API_BASE = 'https://clextensions-a6bvf6amfrc9aeex.centralindia-01.azurewebsites.net';

const PoshmarkIntegrationPage = () => {
  // ========== Extension State ==========
  const [installed, setInstalled] = useState(false);
  const [checking, setChecking] = useState(true);

  // ========== User & Stores State ==========
  const [currentUserId, setCurrentUserId] = useState(null);
  const [stores, setStores] = useState([]);
  const [loadingStores, setLoadingStores] = useState(false);
  const [storeError, setStoreError] = useState(null);
  const [storeSuccess, setStoreSuccess] = useState(null);
  
  // ========== New Store Form State ==========
  const [newStore, setNewStore] = useState({ 
    username: '', 
    marketplace: 'vinted.com' 
  });
  const [addingStore, setAddingStore] = useState(false);

  // ========== Active Tab ==========
  const [activeTab, setActiveTab] = useState('extension');

  // =====================================================
  // 1. LOAD USER ID
  // =====================================================
  const loadUserId = async () => {
    const stored = localStorage.getItem('userId');
    if (stored) {
      setCurrentUserId(stored);
      console.log('✅ UserId from localStorage:', stored);
      return stored;
    }

    try {
      const res = await fetch(`${API_BASE}/api/current-user-id`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (data.success && data.userId) {
        setCurrentUserId(data.userId);
        localStorage.setItem('userId', data.userId);
        console.log('✅ UserId from backend:', data.userId);
        return data.userId;
      }
    } catch (err) {
      console.error('❌ Failed to load userId:', err);
    }
    return null;
  };

  // =====================================================
  // 2. CHECK EXTENSION INSTALLATION
  // =====================================================
  useEffect(() => {
    const checkExtension = () => {
      setChecking(true);
      
      const marker = document.getElementById('poshmark-vinted-extension-detector');
      if (marker && marker.getAttribute('data-installed') === 'true') {
        setInstalled(true);
        setChecking(false);
        return;
      }

      const img = new Image();
      img.src = 'chrome-extension://bkbimjadjjgeammeganjombbncbgdlho/icon128.png';
      img.onload = () => {
        setInstalled(true);
        localStorage.setItem('pm_vt_extension', 'installed');
        setChecking(false);
      };
      img.onerror = () => {
        setInstalled(false);
        localStorage.setItem('pm_vt_extension', 'not_installed');
        setChecking(false);
      };

      setTimeout(() => setChecking(false), 2000);
    };

    checkExtension();
    window.addEventListener('focus', checkExtension);
    return () => window.removeEventListener('focus', checkExtension);
  }, []);

  // =====================================================
  // 3. LOAD USER ID ON MOUNT
  // =====================================================
  useEffect(() => {
    loadUserId();
  }, []);

  // =====================================================
  // 4. FETCH STORES
  // =====================================================
  useEffect(() => {
    if (activeTab === 'stores' && currentUserId) {
      fetchStores();
    } 
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, currentUserId]);

  const fetchStores = async () => {
    if (!currentUserId) {
      setStoreError('User ID not loaded');
      return;
    }

    setLoadingStores(true);
    setStoreError(null);
    setStoreSuccess(null);

    try {
      // 🔥 YEH LINE CHECK KARO – API_BASE use ho raha hai ya nahi
      const url = `${API_BASE}/api/vinted-stores?userId=${currentUserId}`;
      console.log('🔍 Fetching:', url);

      const res = await fetch(url);
      
      // 🔥 Pehle check karo ke response OK hai ya nahi
      if (!res.ok) {
        throw new Error(`HTTP ${res.status} - ${res.statusText}`);
      }

      const data = await res.json();
      console.log('📦 Data:', data);

      if (data.success) {
        setStores(data.stores || []);
        setStoreSuccess(`✅ ${data.stores?.length || 0} store(s) loaded`);
        setTimeout(() => setStoreSuccess(null), 3000);
      } else {
        setStoreError(data.error || 'Failed to load stores');
      }
    } catch (err) {
      console.error('❌ Fetch error:', err);
      setStoreError(err.message || 'Network error');
    } finally {
      setLoadingStores(false);
    }
  };

  // =====================================================
  // 5. ADD STORE
  // =====================================================
  const handleAddStore = async (e) => {
    e.preventDefault();
    if (!currentUserId) {
      alert('User ID not loaded. Please refresh.');
      return;
    }
    if (!newStore.username.trim()) {
      alert('Username is required');
      return;
    }

    setAddingStore(true);
    setStoreError(null);
    setStoreSuccess(null);

    try {
      const url = `${API_BASE}/api/vinted-stores`;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: currentUserId,
          username: newStore.username.trim(),
          marketplace: newStore.marketplace
        })
      });
      
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      
      const data = await res.json();
      if (data.success) {
        setStoreSuccess(`✅ Store "${newStore.username}" added!`);
        setNewStore({ username: '', marketplace: 'vinted.com' });
        fetchStores();
        setTimeout(() => setStoreSuccess(null), 3000);
      } else {
        setStoreError(data.error || 'Failed to add store');
      }
    } catch (err) {
      console.error('❌ Add store error:', err);
      setStoreError(err.message || 'Network error');
    } finally {
      setAddingStore(false);
    }
  };

  // =====================================================
  // 6. DELETE STORE
  // =====================================================
  const handleDeleteStore = async (id, username) => {
    if (!currentUserId) return;
    if (!window.confirm(`Delete store "${username}"?`)) return;

    setLoadingStores(true);
    setStoreError(null);
    setStoreSuccess(null);

    try {
      const res = await fetch(`${API_BASE}/api/vinted-stores/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: currentUserId })
      });
      
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      
      const data = await res.json();
      if (data.success) {
        setStoreSuccess(`✅ Store "${username}" deleted`);
        fetchStores();
        setTimeout(() => setStoreSuccess(null), 3000);
      } else {
        setStoreError(data.message || 'Failed to delete');
      }
    } catch (err) {
      console.error('❌ Delete error:', err);
      setStoreError(err.message || 'Network error');
    } finally {
      setLoadingStores(false);
    }
  };

  // =====================================================
  // 7. RENDER
  // =====================================================
  if (checking) {
    return (
      <div className="poshmark-page">
        <div className="poshmark-card">
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p className="loading-text">Checking extension status...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="poshmark-page">
      <div className="poshmark-card">
        {/* HEADER */}
        <div className="poshmark-header">
          <div className="logo-container">
            <div className="logo-box poshmark-logo">P</div>
            <span className="logo-plus">+</span>
            <div className="logo-box vinted-logo">V</div>
          </div>
          <h1 className="poshmark-title">Poshmark & Vinted</h1>
          <p className="poshmark-subtitle">Automation Extension</p>
          {currentUserId && (
            <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
              User ID: {currentUserId}
            </div>
          )}
        </div>

        {/* TABS */}
        <div className="tabs-container">
          <button
            className={`tab-btn ${activeTab === 'extension' ? 'active' : ''}`}
            onClick={() => setActiveTab('extension')}
          >
            Extension
          </button>
          <button
            className={`tab-btn ${activeTab === 'stores' ? 'active' : ''}`}
            onClick={() => setActiveTab('stores')}
          >
            Vinted Stores
          </button>
        </div>

        {/* TAB CONTENT */}
        {activeTab === 'extension' ? (
          installed ? (
            <div className="installed-section">
              <div className="success-icon">✓</div>
              <h2 className="installed-title">Extension Active</h2>
              <p className="installed-text">Auto listing ready for Poshmark & Vinted</p>
              <button onClick={() => window.open('https://poshmark.com', '_blank')} className="open-button">
                Open Poshmark
              </button>
              <p className="extension-note">Click the extension icon in your browser to configure</p>
            </div>
          ) : (
            <div className="install-section">
              <div className="install-icon">⚡</div>
              <h2 className="install-title">Install Extension</h2>
              <p className="install-text">Auto list on Poshmark & Vinted with one click</p>
              <button
                onClick={() => {
                  window.open(
                    'https://chromewebstore.google.com/detail/poshmark-+-vinted-automat/olleejplenlbopbinimagaokokmdcmhm',
                    '_blank'
                  );
                  setTimeout(() => window.location.reload(), 5000);
                }}
                className="download-button"
              >
                Add to Chrome - Free
              </button>
              <div className="feature-list">
                <div className="feature-item"><span className="feature-check">✓</span><span className="feature-text">Auto Listing</span></div>
                <div className="feature-item"><span className="feature-check">✓</span><span className="feature-text">Cross-post to Vinted</span></div>
              </div>
            </div>
          )
        ) : (
          /* VINTED STORES TAB */
          <div className="stores-tab">
            <h3 className="stores-title">Your Vinted Stores</h3>

            {storeSuccess && <div className="store-message success">{storeSuccess}</div>}
            {storeError && <div className="store-message error">{storeError}</div>}

            <form onSubmit={handleAddStore} className="add-store-form">
              <input
                type="text"
                placeholder="Vinted username (e.g. john_doe)"
                value={newStore.username}
                onChange={(e) => setNewStore({ ...newStore, username: e.target.value })}
                required
                className="store-input"
              />
              <select
                value={newStore.marketplace}
                onChange={(e) => setNewStore({ ...newStore, marketplace: e.target.value })}
                className="store-select"
              >
                <option value="vinted.com">vinted.com</option>
                <option value="vinted.de">vinted.de</option>
                <option value="vinted.fr">vinted.fr</option>
                <option value="vinted.co.uk">vinted.co.uk</option>
                <option value="vinted.it">vinted.it</option>
                <option value="vinted.es">vinted.es</option>
              </select>
              <button type="submit" className="add-store-btn" disabled={addingStore}>
                {addingStore ? 'Adding...' : 'Add Store'}
              </button>
            </form>

            {loadingStores && !stores.length ? (
              <div className="loading-state"><div className="loading-spinner-small"></div> Loading stores...</div>
            ) : stores.length === 0 ? (
              <p className="no-stores">No Vinted stores added yet. Add one above!</p>
            ) : (
              <ul className="store-list">
                {stores.map((store) => (
                  <li key={store.id} className="store-item">
                    <div className="store-info">
                      <strong>@{store.username}</strong>
                      <span className="store-marketplace">{store.marketplace}</span>
                      <span className={`store-status ${store.status === 1 ? 'active' : 'inactive'}`}>
                        {store.status === 1 ? 'Active' : 'Inactive'}
                      </span>
                      <span className="store-created">Added: {new Date(store.created_at).toLocaleDateString()}</span>
                    </div>
                    <button
                      onClick={() => handleDeleteStore(store.id, store.username)}
                      className="delete-btn"
                      title="Delete store"
                    >
                      ✕
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}

        {/* FOOTER */}
        <div className="poshmark-footer">
          <p className="footer-text">
            {activeTab === 'extension'
              ? installed
                ? 'Extension is active • Click icon to manage'
                : 'Works on both platforms • No credit card required'
              : `Manage your Vinted stores (User: ${currentUserId || 'not set'})`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PoshmarkIntegrationPage;